import Layout from "../components/Layout";

export default function Clases() {
    return (
        <Layout title="Clases">

        </Layout>
    )
}